import baseTheme from './baseTheme';
import superAdminTheme from './superAdminTheme';
import { ConfigProvider } from 'antd';
export type ThemeType = 'base' | 'super-admin';
export const getTheme = (themeName: ThemeType): { [key: string]: string } => {
  switch (themeName) {
    case 'base':
      return baseTheme;

    case 'super-admin':
      return superAdminTheme;
    default:
      return baseTheme;
  }
};

export function applyTheme(themeName: ThemeType) {
  const theme = getTheme(themeName);
  ConfigProvider.config({
    theme: {
      primaryColor: theme['--theme-primary'],
    },
  });
  const root = document.documentElement;
  Object.keys(theme).forEach((cssVar) => {
    root.style.setProperty(cssVar, theme[cssVar]);
  });
}
